export default [
  'accounting2@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'diego@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
